module.exports = __webpack_public_path__ + "static/media/dblog4.39db0ace.jpg";